import React from "react";

// Define the type for the component's props if you wanted to make the URL dynamic
interface ContentDashboardEmbedProps {
  // If you want to allow different URLs, define them here:
  // srcUrl: string;
  // title: string;
}

const ContentDashboard: React.FC<ContentDashboardEmbedProps> = () => {
  const embedUrl =
    "https://intact-angler.metabaseapp.com/public/dashboard/de1c0fe6-93b0-4016-b9e0-5d383a111f60";

  return (
    <>
      <iframe
        src={embedUrl}
        title="Content Dashboard"
        frameBorder="0"
        allowFullScreen
        style={{ width: "100%", height: "100vh", border: "none" }}
      ></iframe>
    </>
  );
};

export default ContentDashboard;
